import styled from "styled-components";

import { TabbedDropdown } from "@similarweb/ui-components";

import { StyledTabsListContainer } from "app/pages/sales-intelligence/common-components/dropdown/DropdownTabs/styles";
import { StyledItemName } from "app/pages/sales-intelligence/common-components/form-fields/components/dropdown/DropdownWithTabsHighlightedItem/styles";

export const VERTICAL_OFFSET = "42px";
export const DROPDOWN_HEIGHT = 170;

/** The SDK integrations modal's own dropdown width: 592px modal less its 2x24px padding. */
export const DROPDOWN_WIDTH = 544;

// The menu is virtualized, so with an auto width the widest *mounted* row sizes it and scrolling
// resizes the box. It needs a definite width, and the library's own styled menu is not exported —
// `data-automation="dropdown-content"` is DropdownContent's attribute and a direct child of the container.
const MENU = '& > [data-automation="dropdown-content"]';

export const StyledFilterTabbedDropdown = styled(TabbedDropdown)`
    min-width: 0;

    ${MENU} {
        box-sizing: border-box;
        width: ${DROPDOWN_WIDTH}px;

        /* Tab labels carry live counts ("Technologies (5868)"), so the strip can outgrow any fixed
           width; let it wrap rather than clip a tab. Scoped here — the container is shared. */
        ${StyledTabsListContainer} ul {
            display: flex;
            flex-wrap: wrap;
        }

        ${StyledItemName} {
            min-width: 0;

            /* ellipsis is inert on a flex container, so each line truncates itself */
            > span {
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
`;
